/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeTenantsPutComputeTenant } from "../../funcs/computeTenantsPutComputeTenant.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.PutComputeTenantRequest$inboundSchema,
};

export const tool$computeTenantsPutComputeTenant: ToolDefinition<typeof args> =
  {
    name: "compute-tenants-put-compute-tenant",
    description: `Update a tenant

Cluster-administrator-only idempotent upsert.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await computeTenantsPutComputeTenant(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
